import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import searchContent, { generatePostData } from '@/utils/searchContent';
import { getPathWithParams } from '@/utils/utils';

/**
 *
 * @param {object} searchOptions searchContent options. See utils/searchContent
 * @param {number|String} statecode -
 * @returns {[boolean, Array]} Search Results
 */
export default function useListSearch(searchOptions, statecode) {
  const searchPayload = {
    ...searchOptions,
    ...(statecode && { stateCode: statecode }),
  };
  const pathWithData = getPathWithParams({
    baseURL: process.env.NEW_API_URL,
    url: 'cms/search',
    data: generatePostData(searchPayload),
    method: 'post',
  });

  const cache = useSelector(
    state => JSON.parse(state?.pageLoad?.pageCaches?.[pathWithData]?.data || '{}')?.Results || []
  );
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cached, setCached] = useState(false);

  useEffect(() => {
    if (cache && cache.length) {
      setCached(true);
      return;
    }
    (async function mounted() {
      try {
        setLoading(true);
        const response = await searchContent(searchPayload);

        setResults(response.results);
        setCached(response.cached);
        setLoading(false);
      } catch (error) {
        setResults([]);
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (cached) {
      (async function reMounted() {
        try {
          const response = await searchContent(searchPayload, {
            triggerLoad: false,
            serveFromCache: false,
          });
          if (JSON.stringify(response.results) !== JSON.stringify(results)) {
            // diff detected
            setResults(response.results);
          } else {
            // results are the same
          }
          setCached(false);
        } catch (error) {
          // noop
        }
      })();
    }
  }, [cached]);

  return [loading, results.length ? results : cache];
}
